
import React from 'react';
import ZProps from './zprops';
import AMC from './AMC';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons'

export default class ZooLikesButton extends React.Component {
	constructor(props) {
		super(props);
		let { which, item } = this.props;
		this.state = { selected: (ZProps.get(item.uri + ".history_with_thing") || {})[which] };
	}
	onClick() {
		let { which, item } = this.props;
		let { selected } = this.state;
		AMC.relate(item.uri, which, (err, stats) => {
			item[which + "s"] = Math.max(0, (item[which + "s"] || 0) + (selected ? -1 : 1));
			this.setState({ selected: !selected });
		});
	}
	render() {
		let { which, item } = this.props;
		let { selected } = this.state;
		return (
			<div className="ZooLikesButton">
				<span onClick={this.onClick.bind(this)} className={selected ? "BUTTON_SELECTED_COLOR" : ""}>
					<FontAwesomeIcon icon={which === "like" ? faThumbsUp : faThumbsDown} />
				</span>
				<span className="ZooPageProfileLikes">{item[which + "s"] || 0}</span>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/ZooLikesButton.js